'use client'

import { FastForward, PanToolOutlined } from '@mui/icons-material'
import { Chip, Tooltip } from '@mui/material'
import { useTranslations } from 'next-intl'

import { useActMode } from './actMode'

/** Switches the composer between Ask (every write waits for approval) and Act (routine writes run). */
export default function ActModeToggle({ disabled = false }: { disabled?: boolean }) {
  const t = useTranslations('features.AssistantBar')
  const { actMode, setActMode } = useActMode()
  return (
    <Tooltip title={actMode ? t('actMode') : t('askMode')}>
      <Chip
        icon={actMode ? <FastForward sx={{ fontSize: 16 }} /> : <PanToolOutlined sx={{ fontSize: 14 }} />}
        label={actMode ? t('actModeLabel') : t('askModeLabel')}
        size="small"
        color={actMode ? 'warning' : 'default'}
        variant={actMode ? 'filled' : 'outlined'}
        aria-pressed={actMode}
        disabled={disabled}
        onClick={() => setActMode(!actMode)}
        data-testid="assistant-act-mode"
      />
    </Tooltip>
  )
}
